/**
 * Catálogo: por defecto prioriza `url_imagen` (reimportación / texto maestro).
 * Si la URL del archivo (`imagen`) es el mismo slug base que `url_imagen` pero con sufijo
 * tipo Django (`slug_Xy7AbCd.ext`), se usa `imagen` para que coincida con el objeto real en Spaces.
 *
 * Rutas relativas (`productos/…`, `/productos/…`) se resuelven con el CDN (VUE_APP_CDN_MEDIA_BASE
 * o el mismo origen por defecto que Django TIENDA_CATALOG_MEDIA_BASE_URL).
 */

/** Misma base por defecto que Django `TIENDA_CATALOG_MEDIA_BASE_URL` (CDN DO Spaces). */
const DEFAULT_CDN_MEDIA_BASE =
  'https://tiendas-soluciones-natirales.sfo3.cdn.digitaloceanspaces.com';

function cdnMediaBase() {
  try {
    const raw = (process.env.VUE_APP_CDN_MEDIA_BASE || '').trim();
    if (raw) {
      return raw.replace(/\/+$/, '');
    }
  } catch {
    /* entorno sin process.env */
  }
  return DEFAULT_CDN_MEDIA_BASE;
}

/**
 * Anteponé CDN cuando el valor no es URL absoluta (p. ej. `/productos/Cuaderno_super_poderes.jpg`).
 */
export function resolveCatalogMediaSrc(raw) {
  let s = raw == null ? '' : String(raw).trim();
  if (!s || /^null$/i.test(s) || /^undefined$/i.test(s)) return '';
  if (/^https?:\/\//i.test(s)) {
    return s;
  }
  const base = cdnMediaBase();
  const path = s.replace(/^\/+/, '');
  if (!path) return '';
  return `${base}/${path}`.replace(/([^:])\/{2,}/g, '$1/');
}

function stemProductosFilename(raw) {
  const s = raw == null ? '' : String(raw).trim();
  if (!s) return '';
  const asUrl = /^https?:\/\//i.test(s) ? s : resolveCatalogMediaSrc(s);
  if (!asUrl) return '';
  try {
    const u = new URL(asUrl);
    const seg = u.pathname.split('/').filter(Boolean).pop() || '';
    const dot = seg.lastIndexOf('.');
    return dot > 0 ? seg.slice(0, dot) : seg;
  } catch {
    return '';
  }
}

export function productoImagenSrcPreferMaestro(p) {
  if (!p) return '';
  const t = (s) => (s == null ? '' : String(s).trim());
  if (p.es_mercado_libre) {
    return t(p.url_imagen);
  }
  const im = t(p.imagen);
  const u = t(p.url_imagen);
  if (!im) return u;
  if (!u) return im;
  const bi = stemProductosFilename(im);
  const bu = stemProductosFilename(u);
  if (bi && bu && bi.startsWith(`${bu}_`)) return im;
  if (u) return u;
  return im;
}

/** Dedupe de doble Spaces en URLs absolutas. */
export function normalizeProductoImagenSrc(raw) {
  let s = raw == null ? '' : String(raw).trim();
  if (!s || /^null$/i.test(s) || /^undefined$/i.test(s)) return '';
  const low = s.toLowerCase();
  if (/^https?:\/\//i.test(s) && (low.split('digitaloceanspaces.com').length - 1) >= 2) {
    const lastHttps = s.lastIndexOf('https://');
    const lastHttp = s.lastIndexOf('http://');
    const last = Math.max(lastHttps, lastHttp);
    if (last > 0) s = s.slice(last);
  }
  return s;
}

export function productoImagenParaCatalogo(p) {
  const raw = productoImagenSrcPreferMaestro(p);
  return normalizeProductoImagenSrc(resolveCatalogMediaSrc(raw));
}
